import React, { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Sections
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import BackgroundSection from './sections/BackgroundSection';
import ProjectsSection from './sections/ProjectsSection';
import SkillsSection from './sections/SkillsSection';
import ContactSection from './sections/ContactSection';

// Data for checking visibility
import projects from './data/projects';
import experience from './data/experience';
import education from './data/education';
import skills from './data/skills';
import certifications from './data/certifications';

import profile from './data/profile';
import { initGA, trackPageView } from './utils/analytics';

function MainPage({ sections }) {
  const { projectId } = useParams();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Navbar sections={sections} />
      <main>
        <HeroSection />
        <ProjectsSection initialProjectId={projectId} />
        <BackgroundSection />
        <SkillsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </Box>
  );
}

function App() {
  const hasBackground = education.length > 0 || experience.length > 0;

  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname);
  }, []);

  const sections = [
    { id: 'projects', label: 'Projects', visible: projects.length > 0 },
    { id: 'background', label: 'Experience', visible: hasBackground },
    { id: 'skills', label: 'Skills', visible: Object.keys(skills).length > 0 || certifications.length > 0 },
    { id: 'about', label: 'About', visible: profile.bio && profile.bio.length > 0 },
    { id: 'contact', label: 'Contact', visible: true },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<MainPage sections={sections} />} />
        <Route path="/project/:projectId" element={<MainPage sections={sections} />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
